import * as React from "react";
import { Text, View } from "../../shared/basicComponents/basicComponents";
import { LoaderView } from "../../shared/style/Styles";
export const Spinner: React.SFC<{}> = props => (
  <LoaderView>
    <View className="signal" />
    <Text>Loading resources...</Text>
  </LoaderView>
);
